import { render, staticRenderFns } from "./TestimonialSlider.vue?vue&type=template&id=70f433f2"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports